/**
 * Check if current browser is Mozilla Firefox.
 */
export function isFirefox() {
    const ua = navigator.userAgent;
    return ua.indexOf('Firefox/') > -1;
}
